<template lang="pug">
div
  h2.mb-S Register payment
  BriqMultiselect.mb-S(
  label="Payment method"
  :options="retreivedExternalPaymentMethods"
  display="DisplayName"
  track-by="Name"
  v-model="dialogModel.PaymentMethod"
  required
  :disabled="disabled"
  :error="paymentMethodError"
  data-test-id="payment-method"
  )
  BriqPriceInput.mb-S(
  label="Amount"
  type="number"
  min="0"
  v-model.number="dialogModel.Amount"
  :currencySymbol="currencySymbol"
  required
  :disabled="disabled"
  :error="amountError"
  data-test-id="payment-input"
  )
  BriqTextarea.mb-S(
  label="Description"
  v-model="dialogModel.Description"
  :disabled="disabled"
  data-test-id="payment-description"
  )
  .dialog-actions
    BriqButton.mr-5(@click="close" variant="text" :disabled="disabled || loading") Cancel
    BriqButton.ml-5(@click="addPayment" :disabled="disabled || loading" data-test-id="register-button") Register Payment
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { path } from 'ramda'
import ExternalPaymentApiModel from '@v/bookings/details/ExternalPaymentApiModel.js'
import { required, minValue } from 'vuelidate/lib/validators'
import BriqPriceInput from '@v/components/BriqPriceInput.vue'
import { currencySymbol } from '@/helpers/intlFormatter.js'

export default {
  name: 'RegisterPaymentDialog',
  components: { BriqPriceInput },
  props: {
    disabled: Boolean,
    booking: Object,
  },
  data() {
    return {
      loading: false,
      dialogModel: {
        PaymentMethod: null,
        Amount: this.booking?.AmountOpen ? this.booking.AmountOpen : 0,
        Description: null,
      },
    }
  },
  validations() {
    return {
      dialogModel: {
        PaymentMethod: { required },
        Amount: { required, minValue: minValue(0) },
      },
    }
  },
  computed: {
    ...mapGetters('bookingDetails', ['externalPaymentMethods']),
    firstPaymentOption() {
      return path([0, 'Name'])(this.externalPaymentMethods)
    },
    retreivedExternalPaymentMethods() {
      return this.externalPaymentMethods !== undefined ? this.externalPaymentMethods : []
    },
    amountError() {
      return this.$v.dialogModel.Amount.$error ? 'Amount is required' : null
    },
    paymentMethodError() {
      return this.$v.dialogModel.PaymentMethod.$error ? 'Payment method is required' : null
    },
    currencySymbol() {
      return currencySymbol(this.$locale, this.booking.CurrencyCode)
    },
  },
  methods: {
    ...mapActions('bookingDetails', ['savePayment']),
    async addPayment() {
      this.$v.$touch()
      if (this.$v.$error) return
      this.loading = true
      const body = new ExternalPaymentApiModel(this.dialogModel)
      const success = await this.savePayment(body)
      if (success) {
        this.$notifySuccess(`Payment of ${this.booking.CurrencyCode} ${body.Amount} has been saved.`)
        setTimeout(() => {
          this.loading = false
          this.close()
          this.$emit("reloadBookings")
        }, 2000)
      } else {
        this.$notifyError('Something went wrong, please try again later.')
        this.loading = false
      }
    },
    afterClose() {
      this.dialogModel.PaymentMethod = this.firstPaymentOption
      this.dialogModel.Amount = 0
      this.dialogModel.Description = null
      this.$v.$reset()
    },
    close() {
      this.$emit('close')
    },
  },
  watch: {
    show(v) {
      if (v) {
        this.dialogModel.PaymentMethod = this.firstPaymentOption
        this.dialogModel.Amount = this.booking?.AmountOpen
      }
    },
  },
}
</script>

<style scoped lang="stylus">
.dialog-actions
    display flex
    justify-content center
</style>
